import classNames from 'classnames';
import { type GroupBase, type SelectComponentsConfig, components } from 'react-select';

import { LanguageDisplay } from '../LanguageDisplay/LanguageDisplay';

import styles from './Option.module.scss';

export const Option: SelectComponentsConfig<
  { name: string; id: string },
  false,
  GroupBase<{ name: string; id: string }>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>['Option'] = ({ children, className, ...props }) => {
  const customStyles = (props as any).selectProps?.customStyles;
  const index = props.options.indexOf(props.data);

  return (
    <components.Option className={classNames(className, styles.option)} {...props}>
      <LanguageDisplay
        customStyles={customStyles}
        index={index}
        isMenuOpen={true}
        language={props.data}
        type="option"
      />
    </components.Option>
  );
};
